import { useState} from "react";
import { useAuth } from "../../../../../provider";
import { Formik, Form } from 'formik';
import { useNavigate } from "react-router-dom";
import * as Yup from 'yup';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import Alert from '@mui/material/Alert';
import ButtonForm from "../../../../../components/Button/ButtonForm";
import TextInput from "../../../../../components/Forms/TextInput";
import * as c from '../../../../../constants';
import axios from 'axios';


const AddHeightForm = () => {

  const { state } = useAuth();
  const navigate = useNavigate();

  const url_update = `${c.API_URL}/api/auth/update_heightcm/${state.user.id}/` 
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState();
  const [error, setError] = useState();

  const handleSubmit = async (values) => {
  
    setLoading(true)
    axios.put(url_update, values) 
    .then((response) => {
      if (response.status === 200)
      {
        setMessage(response.status)
        setLoading(false);
        GoToNextStep()
      }
    })
    .catch(function (error) {
      //throw new Error(error)
      setError(error.toJSON());
      if (error.response) { console.log(error.response.data, error.response.status);
      } else if (error.request) { console.log(error.request);
      } else { console.log('Error', error.message);
      }
      console.log(error.config);
    })
  }
     
  const GoToNextStep = () => { navigate( "/VitalsWelcome", { replace: true } ) }

   return (
<>


<Formik
                              
      initialValues={{height_cm: '' }}
      validationSchema={validationUpdateUser}
      onSubmit={(values, { setSubmitting }) => { 
            handleSubmit(values); 
            setSubmitting(false);  
            }}
      > 
 
<Form>
            <TextInput label="enter body height in cm" name="height_cm" type="text" placeholder="enter body height in cm" />

            <ButtonForm name={ 'Submit Data' } disabled={Formik.isSubmitting} />
  
  { loading && <span> Please wait ... fetching data </span>}
  
  {message && 
    
      
        <Alert icon={<EmojiEmotionsIcon fontSize="inherit" />} variant="filled"  severity="info" sx={{mt: 4, borderRadius: '24px'}}>Success!</Alert>
    
   
  }

  {error &&
  
  
      <Alert icon={<ReportProblemIcon fontSize="inherit" />} variant="filled"  severity="warning" sx={{mt: 2, borderRadius: '24px'}}>
        Check your Input !&nbsp;&nbsp;  {JSON.stringify(error)}
      </Alert>
   
  }  
</Form>    
  </Formik>
 
  
  
</>
)}

export default AddHeightForm;


const validationUpdateUser = Yup.object({

  height_cm: Yup.number()
    .positive('must be positive number')
    .required('Required !'),

});